var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("path",{"d":"M0,15V3.32A3,3,0,0,1,3.27,0H26.76A3,3,0,0,1,30,3.29V26.68c0,2.13-1.14,3.24-3.27,3.27-1.95,0-3.88,0-5.84,0-.76,0-1-.28-1-1,0-3.51,0-7,0-10.57,0-.81.32-1.11,1.09-1.09s1.61,0,2.4,0a.85.85,0,0,0,1-.81c.47-3.12.76-2.63-2.06-2.65-2.47,0-2.47,0-2.45-2.45,0-1.81.84-2.67,2.68-2.65.81,0,1.06-.25,1.06-1.06,0-2.4,0-2.4-2.4-2.4-.64,0-1.31,0-2,0a4,4,0,0,0-4.08,4.21c0,1.14,0,2.3,0,3.44,0,.67-.25,1-.92.91s-1.28,0-2,0-.84.2-.84.82c.05,3.22-.4,2.6,2.42,2.65,1.22,0,1.29.07,1.29,1.24,0,3.44,0,6.85,0,10.29,0,.84-.25,1.14-1.12,1.14-3.64,0-7.3,0-10.94,0A2.84,2.84,0,0,1,.05,26.88C0,22.92,0,19,0,15Z","key":1})]);
}

Facebook.defaultProps = {"id":"882f1dd4-35ba-4adb-b7c4-b7b9bb16ec84","width":"20","height":"20","data-name":"Layer 1","viewBox":"0 0 30 30"};

module.exports = Facebook;

Facebook.default = Facebook;
